export default "__VITE_ASSET__Bc1eTK2K__"